// MyBox.tsx
import React from 'react';

interface MyBoxProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  margin?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  radius?: 'none' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
  shadow?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
  bg?: 'white' | 'gray' | 'blue' | 'indigo' | 'transparent';
  border?: boolean;
  borderColor?: string;
  hoverable?: boolean;
  onClick?: () => void;
}

const paddingClasses = {
  none: 'p-0',
  sm: 'p-2',
  md: 'p-4',
  lg: 'p-6',
  xl: 'p-8'
};

const marginClasses = {
  none: 'm-0',
  sm: 'm-2',
  md: 'm-4',
  lg: 'm-6',
  xl: 'm-8'
};

const radiusClasses = {
  none: 'rounded-none',
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  full: 'rounded-full'
};

const shadowClasses = {
  none: 'shadow-none',
  sm: 'shadow-sm',
  md: 'shadow-md',
  lg: 'shadow-lg',
  xl: 'shadow-xl'
};

const bgClasses = {
  white: 'bg-white',
  gray: 'bg-gray-50',
  blue: 'bg-blue-50',
  indigo: 'bg-indigo-50',
  transparent: 'bg-transparent'
};

export const MyBox = ({
  children,
  className = '',
  padding = 'md',
  margin = 'none',
  radius = 'md',
  shadow = 'sm',
  bg = 'white',
  border = false,
  borderColor = 'border-gray-200',
  hoverable = false,
  onClick
}: MyBoxProps) => {
  return (
    <div
      className={`
        ${paddingClasses[padding]}
        ${marginClasses[margin]}
        ${radiusClasses[radius]}
        ${shadowClasses[shadow]}
        ${bgClasses[bg]}
        ${border ? `border ${borderColor}` : ''}
        ${hoverable ? 'hover:shadow-lg hover:-translate-y-1 transition-all duration-200 cursor-pointer' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      {children}
    </div>
  );
};